import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip as MuiTooltip, Fade } from '@mui/material';

function Tooltip(props) {
  const {
    title,
    placement,
    arrow,
    children,
    ...rest
  } = props;

  return (
    <MuiTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
}

Tooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  placement: PropTypes.string,
  arrow: PropTypes.bool,
};

export default Tooltip;
